import React, { useState, useEffect } from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import bannerImage from "../../Images/Banner/Gov-body.webp";

import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import "../../Placement.css";

import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";

import DrVinayVideo from "../../Images/media/Dr. Vinay Agrawal.mp4";
import PMModiVideo from "../../Images/media/PM Modi.mp4";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

// rest of your code stays SAME
const MediaCoverage = () => {
  const [mediaData, setMediaData] = useState([]);
  const [activeTab, setActiveTab] = useState("media");
  const [selectedMedia, setSelectedMedia] = useState(null);

  useEffect(() => {
    fetchMedia();
  }, []);

  const fetchMedia = async () => {
    try {
      const res = await axios.get(
        "https://isbmuniversity.edu.in/admin-portal/mediaApi",
      );
      setMediaData(res.data);
    } catch (error) {
      console.error("Error fetching media:", error);
    }
  };

  const mediaVideos = [
    {
      id: 11,
      url: PMModiVideo,
      title:
        "PM Modi launches ‘Nasha Mukt Yuva for Viksit Bharat Sankalp Abhiyan’ via VC",
    },
    {
      id: 11,
      url: DrVinayVideo,
      title: "ChangeMakers: Dr. Vinay Agrawal, ISBM University",
    },
    {
      id: 10,
      url: "https://www.youtube.com/embed/DSzDkpF8Oug",
      title: "ZEE MPCG के मंच पर उद्योग जगत के दिग्गज",
    },
    {
      id: 9,
      url: "https://www.youtube.com/embed/msaIBvKXjws",
      title: "Media Coverage of IBC24",
    },
    {
      id: 8,
      url: "https://www.youtube.com/embed/d-H0D7OaRp0",
      title: "Media Coverage of Edumate TV",
    },
    {
      id: 7,
      url: "https://www.youtube.com/embed/d-RIDjYSYFE",
      title: "Media Coverage of Swaraj Express",
    },
    {
      id: 6,
      url: "https://www.youtube.com/embed/490Sw_wiZW8",
      title: "Media Coverage of Desh TV",
    },
    {
      id: 5,
      url: "https://www.youtube.com/embed/jgS_lbVI428",
      title: "Media Coverage of IBC24 News",
    },
    {
      id: 4,
      url: "https://www.youtube.com/embed/HqxxM7QkteM",
      title: "Media Coverage of Swaraj Express",
    },
    {
      id: 3,
      url: "https://www.youtube.com/embed/qxvf9KPvKAw",
      title: "Media Coverage of Swaraj Express",
    },
    {
      id: 2,
      url: "https://www.youtube.com/embed/VO2P-OGklh8",
      title: "Media Coverage of Glibs.in news",
    },
    {
      id: 1,
      url: "https://www.youtube.com/embed/MWLWh0hgGa0",
      title: "Media Coverage of Futsal League",
    },
  ];

  return (
    <>
      <title>
        ISBM University Media Coverage | News, Events & Achievements
      </title>
      <meta
        name="description"
        content="Discover ISBM University's media presence, featuring news highlights, achievements, and milestones shaping the future of education."
      />
      <Topnav />
      <section
        className="section-hero-banner ptb-50"
        style={{
          backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${bannerImage})`,
        }}
      >
        <div className="banner-hero-overlay">
          <div className="conatiner-xxl">
            <div className="section-hero-content">
              <h1>Media reflects and builds reputation</h1>
              <ol className="breadcrumb mt-3 text-center mb-0">
                <li className="breadcrumb-item">
                  <a href="/" style={{ color: "#fff", textDecoration: "none" }}>
                    Home
                  </a>
                </li>
                <li
                  className="breadcrumb-item active text-white"
                  aria-current="page"
                >
                  Media Coverage
                </li>
                <hr className="section-divider" />
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section className="media-section ptb-50">
        <div className="container-xxl">
          <div className="row m-0">
            <div className="row mb-5">
              <div className="col-6">
                <div className="media-tabs shadow-lg">
                  <div
                    className={`media-tab ${activeTab === "media" ? "active" : ""}`}
                    onClick={() => setActiveTab("media")}
                  >
                    <div className="tab-icon">
                      <i className="fa fa-video-camera" aria-hidden="true"></i>
                    </div>
                    <div className="tab-content">
                      <h2>Media Coverage</h2>
                      <p>Video news clips and interviews</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-6">
                <div className="media-tabs shadow-lg">
                  <div
                    className={`media-tab ${activeTab === "newspaper" ? "active" : ""}`}
                    onClick={() => setActiveTab("newspaper")}
                  >
                    <div className="tab-icon">
                      <i className="fa fa-newspaper-o" aria-hidden="true"></i>
                    </div>
                    <div className="tab-content">
                      <h2>Newspaper Coverage</h2>
                      <p>Articles and press coverage</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-12">
              <div className="media-tab-content">
                {activeTab === "media" && (
                  <div className="tab-pane active">
                    <div className="media-card">
                      <div className="tab-section-body">
                        <div className="row m-0">
                          {mediaVideos.map((video) => (
                            <div className="pb-4 col-lg-3" key={video.id}>
                              <div className="card rounded-2 h-100 shadow-lg border-0">
                                <div className="ratio ratio-16x9 p-1">
                                  <iframe
                                    src={video.url}
                                    title={video.title}
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                  ></iframe>
                                </div>
                                <div className="card-body">
                                  <h6 className="card-title text-blue fw-bold text-center mb-0">
                                    {video.title}
                                  </h6>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {activeTab === "newspaper" && (
                  <div className="row">
                    {mediaData
                      .filter((item) => item.category === "media")
                      .map((item) => {
                        const isImage = item.file?.match(
                          /\.(jpg|jpeg|png|webp)$/i,
                        );
                        const isPDF = item.file?.match(/\.pdf$/i);

                        // file path
                        const fileUrl = `https://isbmuniversity.edu.in/admin-server/public/uploads/media/${item.file}`;

                        // pdf cover image
                        const previewImage = isImage
                          ? fileUrl
                          : "https://cdn-icons-png.flaticon.com/512/337/337946.png";

                        return (
                          <div
                            className="col-lg-3 col-md-4 col-6 mt-3"
                            key={item.id}
                          >
                            <img
                              src={previewImage}
                              alt="media"
                              style={{
                                width: "100%",
                                height: "250px",
                                objectFit: "cover",
                                cursor: "pointer",
                                border: "4px solid #001e62",
                                borderRadius: "8px",
                                padding: isPDF ? "30px" : "0px",
                                background: "#fff",
                              }}
                              onClick={() =>
                                setSelectedMedia({
                                  type: isImage ? "image" : "pdf",
                                  src: fileUrl,
                                })
                              }
                            />
                          </div>
                        );
                      })}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Image Modal */}
      {selectedMedia && (
        <div className="modal fade show d-block" tabIndex="-1">
          <div className="modal-dialog modal-xl modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {selectedMedia.type === "image"
                    ? "Newspaper Image"
                    : "PDF Viewer"}
                </h5>
                <button
                  className="btn-close"
                  onClick={() => setSelectedMedia(null)}
                ></button>
              </div>

              <div
                className="modal-body text-center"
                style={{
                  height: selectedMedia.type === "pdf" ? "80vh" : "auto",
                }}
              >
                {selectedMedia.type === "image" ? (
                  <img
                    src={selectedMedia.src}
                    alt="media"
                    style={{
                      maxWidth: "100%",
                      maxHeight: "80vh",
                      border: "5px solid #001e62",
                      borderRadius: "8px",
                    }}
                  />
                ) : (
                  <iframe
                    src={selectedMedia.src}
                    title="PDF Viewer"
                    style={{
                      width: "100%",
                      height: "100%",
                      border: "none",
                    }}
                  />
                )}
              </div>

              {selectedMedia.type === "pdf" && (
                <div className="modal-footer">
                  <a
                    href={selectedMedia.src}
                    download
                    className="btn btn-primary"
                  >
                    Download PDF
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      <Footer />
    </>
  );
};

export default MediaCoverage;
